import React, { useEffect, useState } from 'react'
import {  Image } from 'react-bootstrap'
import colorguide from "../../../../assets/lodabranding/colorguide.png"
import '../lodabranding.css'

function ColorGuide() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleContextMenu = (e) => {
    e.preventDefault(); // Disable right-click
  };

  return (
    <div 
      fluid 
      className="container-section" 
      style={{
        backgroundColor: "#181818",
        padding: 0,
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
       
        height: isSmallScreen ? 'auto' : '100vh' // Conditional height based on screen size
      }}
    >
      <Image src={colorguide} alt='color guide' width="100%" draggable="false" onContextMenu={handleContextMenu}  height="auto" />
    </div>
  );
}

export default ColorGuide;
